import React from 'react';
import {
  AppButton,
  AppFormField,
  AppInput,
  AppModal,
  AppTextarea,
} from '../../ui';
import KoikispassDateLink from './KoikispassDateLink';
import { koikispassAgendaUrl } from './magazineHelpers';

function KlubMagazineSetEditModal({
  show,
  busy,
  form,
  date,
  resumeMax = null,
  onChangeForm,
  onClose,
  onSave,
  onRewrite,
}) {
  return (
    <AppModal
      show={show}
      title="Éditer la date"
      onClose={onClose}
      size="lg"
      footer={(
        <>
          <AppButton
            variant="outline-danger-600"
            icon="mdi:robot-outline"
            loading={busy}
            onClick={onRewrite}
          >
            Réécrire cette date
          </AppButton>
          <AppButton variant="outline-secondary" onClick={onClose}>Annuler</AppButton>
          <AppButton variant="primary" loading={busy} onClick={onSave}>Enregistrer</AppButton>
        </>
      )}
    >
      <div className="row g-3">
        {koikispassAgendaUrl(date) ? (
          <div className="col-12 d-flex justify-content-end">
            <KoikispassDateLink row={date}>Voir sur Koikispass</KoikispassDateLink>
          </div>
        ) : null}
        <div className="col-md-6">
          <AppFormField label="Titre" htmlFor="set-titre">
            <AppInput id="set-titre" value={form.titre} onChange={(e) => onChangeForm((f) => ({ ...f, titre: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Thématique" htmlFor="set-thematique">
            <AppInput id="set-thematique" value={form.thematique} onChange={(e) => onChangeForm((f) => ({ ...f, thematique: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Date" htmlFor="set-date-label">
            <AppInput id="set-date-label" value={form.date_label} onChange={(e) => onChangeForm((f) => ({ ...f, date_label: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Lieu" htmlFor="set-lieu">
            <AppInput id="set-lieu" value={form.lieu} onChange={(e) => onChangeForm((f) => ({ ...f, lieu: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-12">
          <AppFormField
            label="Résumé"
            htmlFor="set-resume"
            charValue={form.resume}
            charMax={resumeMax}
          >
            <AppTextarea id="set-resume" rows={4} value={form.resume} onChange={(e) => onChangeForm((f) => ({ ...f, resume: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Prix" htmlFor="set-prix">
            <AppInput id="set-prix" value={form.prix} onChange={(e) => onChangeForm((f) => ({ ...f, prix: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Infos" htmlFor="set-infos">
            <AppInput id="set-infos" value={form.infos} onChange={(e) => onChangeForm((f) => ({ ...f, infos: e.target.value }))} />
          </AppFormField>
        </div>
      </div>
    </AppModal>
  );
}

export default KlubMagazineSetEditModal;
